// extracted by mini-css-extract-plugin
export default {"description":"connect-to-wastepay_description__zp1uG","button":"connect-to-wastepay_button__Kqq5C","wpImgContainer":"connect-to-wastepay_wpImgContainer__aQKwt"};